module.exports = __webpack_public_path__ + "img/bush.e6175f50.png";